import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import AirportChange from '@/assets/svg/AirportChange'

interface AirportChangeNotificationProps {
    actualAirportCode: string
    actualAirportName: string
    actualCityName: string
    searchedAirportCode: string
    journeyType: 'departure' | 'arrival'
}

const AirportChangeNotification: React.FC<AirportChangeNotificationProps> = ({
    actualAirportCode,
    actualAirportName,
    actualCityName,
    searchedAirportCode,
    journeyType
}) => {
    const flightDeparts = "Flight departs from nearby airport: "
    const flightLands = "Flight lands at nearby airport: "

    return (
        <Container 
            className="mt-2 mb-3 ml-12 pr-1" 
            css={{
                backgroundColor: '#FFF4F0',
                borderRadius: '12px 4px 4px 12px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                width: 'fit-content',
                height: '20px'
                
            }}
        >
            <Container className="flex-no-shrink ">
                <AirportChange />
            </Container>
            <Container>
                <Typography 
                    css={{ 
                        color: '#FF4F17',
                        lineHeight: '1.4',
                        whiteSpace: 'nowrap'
                    }} 
                    variant="B3"
                >
                    {`${journeyType === 'departure' ? flightDeparts : flightLands}`}
                    <span style={{ fontWeight: 600 }}>{`${actualAirportName} (${actualAirportCode})`}</span>
                </Typography>
            </Container>
        </Container>
    )
}

export default AirportChangeNotification
